import { createFileRoute } from "@tanstack/react-router";
import { YdelserPage, ydelserHead } from "@/pages/YdelserPage";

export const Route = createFileRoute("/en/services")({
  head: () => ydelserHead("en"),
  component: () => <YdelserPage locale="en" />,
});
